<template>
  <div>
    <div class="clients">
      <div class="w3-container">
        <div class="headerGrid">
          <div>
            <header>
              <h2><template v-if="editing">Edit Client</template><template v-else>Add Client</template></h2>
            </header>
          </div>
          <div>
            <router-link to="/clients" class="w3-button w3-red w3-small w3-right vmiddle">
              <i class="fas fa-times" style="margin-right:8px;"></i>Cancel
            </router-link>
            <template v-if="editing">
              <button @click="updateClient()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
                <i class="fas fa-save" style="margin-right:8px;"></i>Update
              </button>
            </template>
            <template v-else>
              <button @click="saveClient()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
                <i class="fas fa-save" style="margin-right:8px;"></i>Save
              </button>
            </template>
          </div>
        </div>

        <div class="w3-row w3-margin-bottom">
          <div class="outline" style="background:#fafafa;">
            <header class="w3-container dark">
              <h5>Billing Contact</h5>
            </header>
            <div class="cardBody">
              <div class="w3-row-padding w3-padding-v">
                <div class="w3-col s12 m4">
                  <input class="w3-input w3-border" type="text" placeholder="Name" v-model="clientInfo.name">
                </div>
                <div class="w3-col s12 m4">
                  <input class="w3-input w3-border" type="text" placeholder="Company" v-model="clientInfo.company">
                </div>
                <div class="w3-col s12 m4">
                  <select class="w3-select w3-border" style="border-radius:0;" v-model="clientInfo.status">
                      <option value="active">Active</option>
                      <option value="draft">Draft</option>
                      <option value="suspended">Suspended</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                </div>
              </div>

              <div class="w3-row-padding w3-padding-bottom" v-if="!editing">
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="password" placeholder="Password" v-model="clientInfo.password" :class="{'w3-border-red': passwordError.match || passwordError.empty}">
                </div>
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="password" placeholder="Repeat Password" v-model="password2" :class="{'w3-border-red': passwordError.match}">
                </div>
              </div>

              <div class="w3-row-padding w3-padding-bottom">
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="email" placeholder="Email" v-model="clientInfo.email" :disabled="editing">
                </div>
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="text" placeholder="Phone" v-model="clientInfo.phone">
                </div>
              </div>

              <div class="w3-row-padding w3-padding-bottom">
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="text" placeholder="Street Address 1" v-model="clientInfo.address1">
                </div>
                <div class="w3-col w3-half">
                  <input class="w3-input w3-border" type="text" placeholder="Street Address 2" v-model="clientInfo.address2">
                </div>
              </div>

              <div class="w3-row-padding w3-padding-bottom">
                <div class="w3-col w3-third">
                  <input class="w3-input w3-border" type="text" placeholder="City" v-model="clientInfo.city">
                </div>
                <div class="w3-col w3-third">
                  <input class="w3-input w3-border" type="text" placeholder="State" v-model="clientInfo.state">
                </div>
                <div class="w3-col w3-third">
                  <input class="w3-input w3-border" type="number" placeholder="Zip" v-model="clientInfo.zipcode">
                </div>
              </div>

              <template class="w3-row-padding w3-padding-bottom" v-for="(value, propertyName, index) in clientInfo">
                <div class="w3-row-padding w3-padding-bottom" :key="index" v-if="value == '' && propertyName !== 'address2' && propertyName !== 'emhash' && propertyName !== 'gravatar' && propertyName !== 'user_group'">
                  <span class="w3-text-red" style="text-transform:capitalize;">{{propertyName}} required</span>
                </div>
              </template>

              <template v-if="state.error && state.error.message && state.error.message !== ''">
                <div class="w3-row w3-padding w3-text-red w3-center">
                  {{state.error.message}}
                </div>
              </template>

              <!-- <div class="w3-container">
                <div class="headerGrid w3-padding-bottom">
                  <div></div>
                  <div>
                    <router-link to="/clients" class="w3-button w3-red w3-small w3-right vmiddle">
                      <i class="fas fa-times" style="margin-right:8px;"></i>Cancel
                    </router-link>
                    <template v-if="editing">
                      <button @click="updateClient()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
                        <i class="fas fa-save" style="margin-right:8px;"></i>Update
                      </button>
                    </template>
                    <template v-else>
                      <button @click="saveClient()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
                        <i class="fas fa-save" style="margin-right:8px;"></i>Save
                      </button>
                    </template>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore'

export default {
  name: 'addClient',
  data() {
    return {
      state: dataStore.state,
      password2: '',
      clientInfo: {
        status: 'active'
      },
      passwordError: {
        match: false,
        empty: false
      },
      editing: false
    }
  },
  mounted() {
    this.editing = false
    if (this.state.admin.client) {
      if (this.state.admin.client.email) {
        this.clientInfo = this.state.admin.client
        this.editing = true
      }
    }
  },
  beforeDestroy() {
    this.state.admin.client.email = ''
    // console.log(this.state.admin)
  },
  methods: {
    saveClient() {
      this.passwordError.empty = false
      this.passwordError.match = false
      if (this.clientInfo.password === (undefined || '' || null)) {
        this.passwordError.empty = true
      } else {
        if (this.clientInfo.password !== this.password2) {
          this.passwordError.match = true
          return
        }
        // Have password and it matches, proceed
        dataStore.saveClient(this.clientInfo).then((result) => {
          if (result === 'success') {
            this.$router.replace('clients')
          }
        })
      }
    },
    updateClient() {
      dataStore.updateClient(this.clientInfo).then((result) => {
        if (result === 'success') {
          this.$router.replace('clients')
        }
      })
    }
  }
}
</script>

<style scoped>
/* .w3-input, .w3-select {background:#fff;} */
</style>



// WEBPACK FOOTER //
// src/components/ClientAdd.vue